module.exports = __webpack_public_path__ + "media/images/Informe-Inventario-cb82c36314e570c8962101e2545505fb.png";